import StorageUtil from '@/utils/storage'
import { domain } from '@/config/env'
import {
  LOCAL_STORAGE_USER_INFO,
  TOKEN_INVALID_EVENT,
  NO_CREDITS_EVENT,
  JobPollStatus,
} from '@/constants'

const defaultOptions = {
  baseURL: `https://${domain}`,
  headers: {
    'Content-type': 'application/json; charset=UTF-8'
  }
}

const customOptionKeys = ['baseURL', 'params', 'data', 'body']

async function fetcher(url = '', data, options = {}) {
  // Compose url
  const baseURL = defaultOptions.baseURL.endsWith('/')
    ? defaultOptions.baseURL
    : defaultOptions.baseURL + '/'
  const routeURL = url.startsWith('/') ? url.slice(1) : url
  let fullUrl = baseURL + routeURL

  const params = options.params
  // 处理get请求
  if (options.method === 'GET' && params && Object.keys(params).length > 0) {
    let paramsStr = ''
    const paramsStrArr = Object.entries(params).map(
      ([key, value]) => `${key}=${value}`
    )
    paramsStr = `?${paramsStrArr.join('&')}`

    fullUrl = `${baseURL}${routeURL}${paramsStr}`
  }

  // Compose fetch init options
  let initOptions = {}
  // 合并header
  Object.keys(defaultOptions).forEach((key) => {
    const value = defaultOptions[key]
    if (customOptionKeys.includes(key)) return
    if (key === 'headers') {
      initOptions['headers'] = {...initOptions['headers'], ...value}
      return
    }
    initOptions[key] = value
  })
  if (data && data instanceof FormData) {
    initOptions.body = data
    // 上传formData需要删除Content-type
    delete initOptions.headers['Content-type']
  }
  if (data && !(data instanceof FormData)) {
    initOptions.body = JSON.stringify(data)
  }

  Object.keys(options).forEach((key) => {
    const value = options[key]
    if (customOptionKeys.includes(key)) return
    if (key === 'headers') {
      initOptions['headers'] = {...initOptions['headers'], ...value}
      return
    }
    initOptions[key] = value
  })

  // pre fetch
  initOptions = await preFetch(initOptions, { routeURL })
  if (!initOptions) return

  try {
    const response = await fetch(fullUrl, initOptions)
    const data = await response.json()
    let result = {
      data,
      status: response.status,
      statusText: response.statusText,
      ok: response.ok,
    }

    result = await postFetch(result, initOptions, {routeURL})
    return result
  } catch (error) {
    // Network failure or anything prevented the request from completing.
    console.error('Fetch error:', error)
  }
}

fetcher.get = async function (url, config) {
  return await fetcher(url, null, {...config, method: 'GET'})
}
fetcher.post = async function (url, data, config) {
  return await fetcher(url, data, {...config, method: 'POST'})
}
fetcher.put = async function (url, data, config) {
  return await fetcher(url, data, {...config, method: 'PUT'})
}
fetcher.patch = async function (url, data, config) {
  return await fetcher(url, data, {...config, method: 'PATCH'})
}
fetcher.delete = async function (url, config) {
  return await fetcher(url, null, {...config, method: 'DELETE'})
}

async function preFetch(config, {routeURL}) {
  // before fetch
  const userInfo = localStorage.getItem('userInfo') && localStorage.getItem('userInfo') != 'null' ? JSON.parse(localStorage.getItem('userInfo')) : '';

  // 如果没有 token，说明是未登录状态
  // if (!userInfo || !userInfo.isLogin || !userInfo.token) {
  //   // 用户未登录,将缓存状态更新为未登录
  //   let obj = userInfo;
  //   obj.isLogin = false;
  //   localStorage.setItem('userInfo', JSON.stringify(obj));
  // }
  const token = userInfo?.token
  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: token,
    }
    config.headers = {
      ...config.headers,
      'Product-Code': '067003',
    }
  }
  return config
}

let meetInvalidToken = false

async function postFetch(response, initOptions, {routeURL}) {
  // status code between 200-299
  if (response.ok) {
    const code = response?.data.code
    const message = response?.data?.message
    switch (code) {
      case 100000:
        meetInvalidToken = false
        return {
          code: response.data.code,
          data: response.data.result,
          message: response.data.message
        }
      case 200008:
        console.log('token invalid, account logout!')
        break
      case 300002:
        return {
          code: response.data.code,
          data: response.data.result,
          message: response.data.message
        }
      case 200003:
      case 200004:
      case 200006:
      case 300001:
      case 300003:
      case 300004:
      case 300005:
      case 300006:
      case 300008:
        // this.$message({
        //   message: message[this.$i18n.locale],
        //   type: "error",
        //   showClose: true,
        // })
        return { code: response.data.code, data: response.data.result, message: response.data.message }
      default:
        return { code, error: message ? message : 'Unknown server error' }
    }
  } else {
    return {error: `Server error: ${response.status}`}
  }
}

/**
 * 轮询接口调用逻辑
 * @param callback 回调函数，用于更具接口返回值判断是否可以结束任务
 * @param intervalTime 调用间隔时间
 * @param currentCount 当前执行次数
 * @param executionCountLimit 执行次数限制
 */
let timer = null
async function requestPoll(callback, intervalTime, currentCount = 0, executionCountLimit = null) {
  // 到达执行次数上线直接结束任务
  if (executionCountLimit && executionCountLimit > currentCount) {
    console.log('poll request reach limit:', executionCountLimit)
    return
  }
  // 清除旧的计数器
  clearTimeout(timer)
  // 判断是否需要继续执行
  const isSuccess = await callback()
  if (isSuccess === JobPollStatus.STOP) {
    // 如果接口调用成功，直接结束任务
    return
  }
  timer = setTimeout(() => {
    requestPoll(callback, intervalTime, currentCount + 1, executionCountLimit)
  }, intervalTime);
}

export {
  fetcher,
  requestPoll
}
